/**
 * useLocale - subscribe React to the i18n locale so components re-render when
 * the language toggles. `t()` reads the current locale internally; this hook
 * just forces a re-render on the "locale-change" event.
 */
import { useSyncExternalStore } from "react";
import { getLocale, setLocale, type Locale } from "@/lib/i18n";

function subscribe(callback: () => void): () => void {
  window.addEventListener("locale-change", callback);
  return () => window.removeEventListener("locale-change", callback);
}

export function useLocale(): { locale: Locale; setLocale: (l: Locale) => void } {
  const locale = useSyncExternalStore(subscribe, getLocale, getLocale);
  return { locale, setLocale };
}
